import React, { useContext } from 'react';
import _ from 'lodash';
import MenuProvider from 'react-flexible-sliding-menu';
import Loading from '../../../components/Loading';
import DrawerMenu from '../../../components/DrawerMenu';
import PageNotFound from '../../../components/PageNotFound';
import PageLayout from '../../shared/PageLayout';
import { SnapFlowContext } from '../context';
import { Title } from '../styles';
import { ContentWrapper, LPTitle } from '../../styles';
import LinkItem from '../../../components/LinkItem';
import { LinkWrapper } from './styles';

const SnapFlowPageContent = () => {
  const {
    contextData: {
      requestData: { queryError, queryLoading, queryData },
    },
  } = useContext(SnapFlowContext);

  if (queryLoading) {
    return (
      <PageLayout isDark>
        <Loading />
      </PageLayout>
    );
  }

  if (queryError) {
    return (
      <PageLayout isDark>
        <LPTitle> Oops! something went wrong: </LPTitle>
        <Title>{queryError.message}</Title>
      </PageLayout>
    );
  }

  const snapFlowPageData = queryData.getAccount;
  const {
    snapflowTitle,
    description,
    coverMedia,
    avatarMedia,
    isVerified,
    smartLinks,
    virtualPhoneNumbers,
  } = snapFlowPageData;
  const splitName = snapflowTitle.split(' ');
  const avatarUrl = avatarMedia ? avatarMedia.uri : '';
  const firstItem = smartLinks.find((i) => i.position === 0);

  const numbers = virtualPhoneNumbers.map((f) => f.friendlyName);

  const account = {
    avatarImg: avatarUrl,
    firstName: splitName[0],
    lastName: splitName[1],
    description,
    isVerified,
    extraText: ` TEXT ME: ${numbers.join(', ')}`,
  };

  if (_.isNull(snapFlowPageData)) {
    return (
      <PageLayout isDark>
        <PageNotFound />
      </PageLayout>
    );
  }

  return (
    <MenuProvider MenuComponent={DrawerMenu}>
      <PageLayout coverMedia={coverMedia} isDark showUserInfo account={account}>
        {firstItem && (
          <LinkItem
            isPrime
            title={firstItem.title}
            subTitle={firstItem.subtitle}
            btnLabel={firstItem.btnLabel}
            icon={firstItem.iconMedia && firstItem.iconMedia.uri}
            url={firstItem.url}
          />
        )}
        <ContentWrapper nopadding>
          <LinkWrapper>
            {smartLinks.map((link) => {
              const {
                position,
                title,
                subtitle,
                btnLabel,
                iconMedia: { uri },
                url,
              } = link;

              return (
                position !== 0 && (
                  <LinkItem
                    isPrime={false}
                    key={position}
                    title={title}
                    subTitle={subtitle}
                    btnLabel={btnLabel}
                    icon={uri}
                    url={url}
                  />
                )
              );
            })}
          </LinkWrapper>
        </ContentWrapper>
      </PageLayout>
    </MenuProvider>
  );
};

export default SnapFlowPageContent;
